/*
 * Метод вычисления контраста цвета по его hex коду
 * реузльтат от 0 (черный) до 255 (белый)
 */

export const getContrast = function (hexColor) {
    // Удаление символа # из HEX цвета
    hexColor = hexColor.replace('#', '');

    if (hexColor.length === 3) {
        // краткая нотация
        hexColor = hexColor
            .split('')
            .map((letter) => letter + letter)
            .join('');
    }

    // Получение значений RGB
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);

    // Вычисление яркости (формула YIQ)
    return (r * 299 + g * 587 + b * 114) / 1000;
};
